Customer.Ticket ||= {}

class Customer.Ticket.TicketView extends Backbone.View
  template: JST['backbone/templates/customer/ticket/ticket']

  events:
    'change #show-events-checkbox': '_onShowStatusEventsChange'
    'click #close': 'onClose'
    'click #close': 'onClose'
    'click #reopen': 'onReopen'
    'click #history-btn': 'showHistory'
    'click #rollback': 'rollback'
    'click #save_note': 'onSaveNote'
    'click #show-context-participants': 'onShowContextParticipants'
    'click #hide-context-participants': 'onHideContextParticipants'
    'click #ticket-schedule': 'onClickTicketSchedule'
    'keyup #note_text': '_keepCustomerSessionAlive'
    'show.bs.modal #add_note': '_keepCustomerSessionAlive'

  afterRender: ->

  onAssignTo: (event) =>
    super event
    @afterRender = =>
      @$el.find('#rollback_container').show()
      @afterRender = ->

  initialize: (@options = {}) ->
    @responseTemplates = new Customer.ResponseTemplateCollection.getCollection()
    _.extend(@options, {responseTemplates: @responseTemplates})
    @defaultMinutesForTicketsScheduler = @options.default_minutes_for_tickets_scheduler
    @reRender = true
    @listenTo(@model, 'change', () => if @reRender then @render else @reRender = true)
    @listenTo(@model, 'ticket:assign:success', @onTicketAssignSuccess)
    @listenTo(@model, 'ticket:assign:error', @onTicketAssignError)
    @listenTo(@model, 'ticket:saved:success', @onTicketSavedSuccess)
    @listenTo(@model, 'ticket:saved:error', @onTicketSavedError)
    @listenTo(@model, 'action:follow', @onFollowChanged)
    @listenTo(@model, 'ticket:prioritize:success', @onTicketPriorityzeSuccess)
    @processingTicket = false

    @listenTo(@model, 'add:note', @onAddedNote)
    @listenTo(@model, 'add:visible_event', @onAddVisibleEvent)

    @listenTo(@model, 'ticket:moreLoaded', @renderMore)
    @listenTo(@model, 'ticket:newLoaded', @renderNew)

    @headerView = new Customer.Ticket.TicketHeaderView(model: @model, data: @options)

    extraParameters = {
      ticketView: @,
      userProfileData: @_userProfileData()
    }
    @interactionsView = new Customer.Ticket.InteractionsView(_.extend(@options, extraParameters))
    @listenTo(Backbone, 'interactionResponseBox:open', @hideResponse)
    @listenTo(Backbone, 'interactionResponseBox:close', @showResponse)
    @listenTo(Backbone, 'interactionResponseBox:open', @focusResponseBox)
    @listenTo(Backbone, 'interaction:update', @updatePredefinedAnswers)
    @listenTo(@interactionsView, 'clicked:user', @onClickUser)
    @listenTo(@model, 'ticket:contextInteractionsLoaded', @toggleShowActiveParticipants)

    @staleNoticeView = new Customer.StaleNoticeView()
    @listenTo(@staleNoticeView,'refresh:tab', @onClickStaleRefresh)
    @ticketChangeStatusToPendingView = new Customer.Dashboard.TicketChangeStatusToPendingView(ticket: @model)
    @listenTo(@ticketChangeStatusToPendingView, 'ticket:tab:closeRequired', @closeTicketTab)

    @model.loadCurrentUserAppointment()
    @$el.find('#ticket-schedule').html(I18n.t('customer.dashboard.conversations.details.scheduling.loading'))
    @listenToOnce(@model, 'scheduleLoaded', @updateScheduleButton)
    @intervalIDs = []
    @showEventsCheckbox = true

  _onProfileAttributesChange: (attributes) =>
    @userProfileAttributesCollection = attributes

  startFetchingUpdates: =>
    @model.fetchNewInteractions()
    intervalTime = Customer.refreshIntervals.newInteractionsByType[@model.type()]
    intervalTime = Customer.refreshIntervals.defaultNewInteractions unless intervalTime
    @intervalIDs.push(setInterval @model.fetchNewInteractions, intervalTime)
    @intervalIDs.push(setInterval @checkIfRefreshIsNeeded, Customer.refreshIntervals.checkRefreshNeeded)

  stopFetchingUpdates: =>
    _.each @intervalIDs, (intervalID) -> clearInterval intervalID

  checkIfRefreshIsNeeded: =>
    return if @staleNoticeView.isRefreshNeeded()
    url = '/customer/ticket/refresh_is_needed?id=' + @model.id + '&fields=' +
      JSON.stringify
        status: @model.get('status')
        assigned_to_id: @model.get('assigned_to_id')
        assigned_to_name: @model.get('assigned_to_name')
    $.get url, (response) =>
      if response['refresh_is_needed'] and not @updatingStatus and not @updatingAssignment
        @showRefreshPrompt()

  showRefreshPrompt: =>
    @staleNoticeView.showRefreshNeeded()
    @adjustHeight()

  onClickStaleRefresh: ->
    @trigger('refresh:tab')
    @staleNoticeView.hideRefreshNeeded()

  openNoteModal: ->
    @$el.find('#add_note').modal('toggle')

  onAddedNote: (_notesCollection) =>
    [..., newNote] = _.where(@model.interactionsToRender(), {viewType: 'note'})
    @renderNew [newNote]

  onAddVisibleEvent: (_visibleEventCollection) =>
    [..., newVisibleEvent] = _.where(@model.interactionsToRender(), {viewType: 'visible_event'})
    @renderNew [newVisibleEvent] if @shouldRenderViewEvent(newVisibleEvent)
    @checkResponseStatusAfterEvent(newVisibleEvent)

  shouldRenderViewEvent: (newVisibleEvent) =>
    definition = @findDefinitionBehaviorView(newVisibleEvent.get('sub_type'))
    return true unless definition
    _view_amount = 0
    _.map(@interactionsView.interactionViews, (_view) ->
      if _view.viewSubType
          _view_amount++ if _view.viewSubType() == definition.sub_type
    )
    if definition.max_amount
      return _view_amount < definition.max_amount

    return true

  checkResponseStatusAfterEvent: (newVisibleEvent) =>
    if (newVisibleEvent.get('sub_type') == 'webchat_finalized')
      @onResponseDestroy()

  onClickUser: (interaction) ->
    if interaction.isResponseFromClient()
      console.log("Clicked a brand user: nothing happens")
    else
      @ticketDetailsBoxView.showUserOf(interaction)

  onClickTicketSchedule: ->
    @_keepCustomerSessionAlive()
    if @model.get('userAppointment')
      @onScheduleLoaded()
    else
      @model.loadCurrentUserAppointment()
      @$el.find('#ticket-schedule').html(I18n.t('customer.dashboard.conversations.details.scheduling.loading'))
      @listenTo(@model, 'scheduleLoaded', @onScheduleLoaded)

  addScheduledIndicator: ->
    @$el.find('#scheduled-indicator').addClass('ticket-scheduled').removeClass('ticket-unscheduled')

  onScheduleDeleted: ->
    @$el.find('#scheduled-indicator').removeClass('ticket-scheduled').addClass('ticket-unscheduled')


  updateAfterSchedule: (ticketStatus, ticketLockVersion)->
    @addScheduledIndicator()
    @model.updateLockVersion(ticketLockVersion)
    @model.updateStatus(ticketStatus)
    @updateStatusButton(ticketStatus)
    @_updateFutureAppointmentsList()

  onScheduleLoaded: ->
    @updateScheduleButton()
    @$el.find('#ticket-schedule-text').html(I18n.t('customer.dashboard.conversations.details.scheduling.schedule_ticket'))
    @scheduleView = new Customer.Ticket.ScheduleView(ticket: @model,defaultMinutesForTicketsScheduler: @defaultMinutesForTicketsScheduler)
    @listenTo(@scheduleView, 'delete:schedule', @onScheduleDeleted)
    @listenTo(@scheduleView, 'disable:schedule', (value) => @disableScheduleButton(value))
    @listenTo(@scheduleView, 'ticket:tab:closeRequired', @closeTicketTab)
    @listenTo(@scheduleView, 'ticket:saved:error', @onTicketSavedError)
    if (@model.get('userAppointment').date != null)
      @listenTo(@scheduleView, 'update:schedule', @updateAfterSchedule)
      @$el.find('#ticket-schedule-modal').html(@scheduleView.renderEditSchedule().el)
    else
      @listenTo(@scheduleView, 'create:schedule', @updateAfterSchedule)
      @$el.find('#ticket-schedule-modal').html(@scheduleView.renderNewSchedule().el)

  # This is not just for salesforce anymore.
  onClickCreateCrmCase: (integration_name) =>
    @_keepCustomerSessionAlive()
    integration = @model.get('integrations').get(integration_name)
    mandatoryFields = integration.mandatoryFields()
    translations = integration.translations()
    @ticketDetailsBoxView.validateCrmData(mandatoryFields, (result) =>
      if result.success
        @listenToOnce(@model, 'exportToCrm:finished', (response) =>
          @ticketSalesforceButtonView.render() if integration_name == 'salesforce'
          if response.success
            @ticketDetailsBoxView.onClickConversationTitle()
            showNotice(I18n.t('customer.dashboard.conversations.details.integrations.crm_case_created', translations))
        )
        @profileId = result.profile_id
        if _.isEmpty(integration.get('crm_id'))
          integration.onClickExternalCrm(@profileId)
        else
          integration.exportToCrm(@profileId, '')
      else
        showError(result.message)
        @ticketSalesforceButtonView.render() if integration_name == 'salesforce'
    )

  onSelectContact: (contact_id) =>
    console.log("Selected contact: ", contact_id)
    integration = @model.get('integrations').get('salesforce')
    integration.exportToCrm(@profileId, contact_id)

  getTranslationFor: (status) ->
    I18n.t('customer.dashboard.conversations.status.' + status.toLowerCase().replace(' ', '_'))

  onAssignmentChanged: (userId, groupId, selectedOptionText, reRender) =>
    @headerView.$el.find('#loading-assignment').show()
    @headerView.$el.find('#assign-to-me').hide()
    @reRender = reRender
    if userId == Keepcon.current_user.id && @model.get('assigned_to_id') != userId && @model.get('status') == 'Closed'
      @selfAssignClosed()
    else
      @assignTicket(userId, groupId)
    if userId
      @sendNotifications(selectedOptionText, [userId])
    else if groupId
      @sendGroupNotifications(groupId)

  onChangePrivacySelector: (selectedPrivacy) ->
    @interactionsView.updateVisibilityByPrivacy(selectedPrivacy)

  onCloseTab: =>
    #Esto es para compatibilidad con SummaryView

  onClose: =>
    @_keepCustomerSessionAlive()
    _title = I18n.t('customer.dashboard.conversations.details.close_ticket_confirmation.are_you_sure')
    _aditional_text = I18n.t('customer.dashboard.conversations.details.close_ticket_confirmation.description')
    if @model.isWebchat()
      _aditional_text += ' ' + if @model.isWebchatFinalized() then '' else I18n.t('customer.dashboard.conversations.details.close_ticket_confirmation.and_webchat')

    swal
      title: _title
      text: _aditional_text
      type: 'warning'
      showCancelButton: true
      confirmButtonClass: 'btn-danger'
      confirmButtonText: I18n.t('customer.dashboard.conversations.details.close_ticket_confirmation.confirm')
      cancelButtonText: I18n.t('customer.dashboard.conversations.details.close_ticket_confirmation.cancel')
      closeOnConfirm: true
      @_closeTicket

  _closeTicket: =>
    @disableStateButtons()
    @onScheduleDeleted() # Ticket Appointments are removed when closing a ticket
    @ticketDetailsBoxView.onTicketClose()
    @updatingStatus = true
    @saveTicket({status: 'Closed'}, (response) =>
      if response.success
        @updateStatusButton('Closed')
        if @model.isWebchat()
          @model.addWebchatCloseEvent(response.event_detail) if response.event_detail
          @onResponseDestroy()
        @closeTicketTab()
    )

  closeTicketTab: =>
    @trigger('ticket:tab:closeRequired')

  onReopen: =>
    @_keepCustomerSessionAlive()
    @disableStateButtons()
    @updatingStatus = true
    @saveTicket(status: 'Assigned', @model.fetchNewInteractions)
    @updateStatusButton('Assigned')

  addTicketChangeStatusToPendingView:=>
    @$el.find('.conv-resume-close').prepend(@ticketChangeStatusToPendingView.render().el)
    @ticketChangeStatusToPendingView.delegateEvents();

  saveTicket: (attributes, successCallback) ->
    @trigger('startProcessing')
    @model.saveTicket(attributes, successCallback)

  assignTicket: (userId, groupId) ->
    @updatingAssignment = true
    @model.assignTicket(userId, groupId)

  selfAssignClosed: () ->
    @model.selfAssignClosedTicket()

  getTicket: ->
    @model

  getDistinguishedContent: ->
    @model.distinguishedContent()

  onTicketAssignSuccess: () =>
    @headerView.$el.find('#loading-assignment').hide()
    @headerView.$el.find('#assign-to-me').show()
    @headerView = new Customer.Ticket.TicketHeaderView(model: @model, data: @options)
    if @reRender then @render() else @reRender = true
    @updatingAssignment = false
    @_renderTicketDetailsBox()
    @model.fetchNewInteractions()

    if !Keepcon.current_user.can_read_not_assigned_conversations
      @trigger('refresh:tab')

  onTicketPriorityzeSuccess:(lock_version) =>
    @model.updateLockVersion(lock_version)
    @ticketDetailsBoxView.hidePrioritySpinner()

  onTicketSavedSuccess: () =>
    @trigger('stopProcessing')
    @ticketChangeStatusToPendingView.render()
    @enableStateButtons()
    if @model.get('can_close')
      @$el.find('button#close').removeAttr('disabled')
    else
      @$el.find('button#close').attr('disabled', 'disabled')
    @updatingStatus = false

  onTicketAssignError: (response) =>
    @headerView.$el.find('#loading-assignment').hide()
    @headerView.$el.find('#assign-to-me').show()
    @manageError(response)
    @updatingAssignment = false

  onTicketSavedError: (response) =>
    @trigger('stopProcessing')
    @ticketChangeStatusToPendingView.render()
    @enableStateButtons()
    @manageError(response)
    @updatingStatus = false

  manageError:(response) =>
    if response.status == 400
      showError @ticketDetailsBoxView.onAttributesValidationError(
        JSON.parse(response.responseText),
        response.skipAttributesErrorDetail
      )
    else if response.message
      showError response.message
    else if response.error_code == 'stale_dialogue'
      swal({
          title: I18n.t('customer.dashboard.conversations.stale_dialogue.message')
          type: 'warning'
          showCancelButton: true
          confirmButtonClass: 'btn-success'
          confirmButtonText: I18n.t('customer.dashboard.conversations.stale_dialogue.refresh')
          cancelButtonText: I18n.t('customer.dashboard.conversations.stale_dialogue.dismiss')
          closeOnConfirm: true
        }, =>
          @trigger('refresh:tab')
          return
      )
    else
      showError I18n.t('generic_error_message')
      jsLogger.error 'Error updating interaction. Response: ' + JSON.stringify response

  render: =>
    @$el.html(@template(
      model: @model.asJson()
      statuses: @options.statuses
      priorities: @options.priorities
      users: @options.users
      current_user: Keepcon.current_user
      processing: @processingTicket
      self: @
    ))
    @addTicketChangeStatusToPendingView()
    if @model.canCreateExternalTicket('salesforce')
      @ticketSalesforceButtonView = new Customer.Dashboard.TicketSalesforceButtonView(ticket: @model)
      @$el.find('#span-create-crm-case').append(@ticketSalesforceButtonView.render().el)
      @ticketSalesforceButtonView.bind('onClickCreateCrmCase', @onClickCreateCrmCase)
      @ticketSalesforceButtonView.bind('onSelectContact', @onSelectContact)

    if @model.canCreateExternalTicket('patagonia')
      @ticketCreatePatagoniaCrmCaseActionView.unbindEvents() if @ticketCreatePatagoniaCrmCaseActionView
      @ticketCreatePatagoniaCrmCaseActionView = new Customer.Dashboard.TicketCreatePatagoniaCrmCaseActionView(
        model: new Customer.TicketCreatePatagoniaCrmCaseAction(ticket: @model),
        el: @$el.find('#create-patagonia-crm-case-action')
      )
      @ticketCreatePatagoniaCrmCaseActionView.onClickCreateCrmCase = @onClickCreateCrmCase
      @ticketCreatePatagoniaCrmCaseActionView.render() if @ticketCreatePatagoniaCrmCaseActionView.canRender()


    @_renderTicketDetailsBox()
    @ticketHistory = new Customer.Dashboard.TicketHistoryView
      ticketId: @model.id
      el: @$el.find('#conversation-history')
    @$el.find('span#header').append(@headerView.render().el)
    @_renderPrivacySelector() if @model.isByUser()
    @$el.find('.stale-notice-container').html(@staleNoticeView.render().$el)
    @renderInteractionsView()
    @beforeAdjustHeight()
    @adjustHeight()
    setTimeout () =>
      @$el.removeClass('invisible') # Required for CSS3 animations to work
      @getResponseContainer().find('#response').focus()
    , 100
    @toggleScheduleButton()

    @listenTo(@headerView.assignmentView, 'assignmentChange', @onAssignmentChanged)
    @_setStatusEventsCheckbox(@showEventsCheckbox)

    if @model.isCut()
      false

    if @model.hasCommunicationBlocked()
      @_disableCommunication()

    @afterRender()
    @

  _renderTicketDetailsBox: ->
    if @ticketDetailsBoxView
      @model.asyncNotes = undefined
      @ticketDetailsBoxView.ticket = @model
    else
      @ticketDetailsBoxView = new Customer.Dashboard.TicketDetailsBoxView(ticket: @model, priorities: @options.priorities, account_users: @options.account_users)
    @$el.find('.ticket-details-box').append(@ticketDetailsBoxView.render().el)

  _renderPrivacySelector: ->
    @privacySelectorView = new Customer.Ticket.PrivacySelectorView(selectedPrivacy: 'all')
    @$el.find('#privacy-selector-container').append(@privacySelectorView.render().el)
    @listenTo(@privacySelectorView, 'change:privacySelector', @onChangePrivacySelector)

  renderInteractionsView: ->
    @$el.find('#interactions').html(@interactionsView.render().el)

  _scrollToEnd: ->
    @$el.find('#nano-detail').animate
      scrollTop: @$el.find('.nano-content.sentiment-position-baseline').height()

  renderContextInteractionsView: ->
    @$el.find('#context-interactions').html(@contextInteractionsView.render().el)
    @model.loadContextInteractions()

  beforeAdjustHeight: ->
    @interactionsView.renderInteractions(@model.interactionsToRender())
    @renderDistinguishedContent()
    if @model.hasFooterReplyBox()
      @renderResponse()
      @showResponse()

    if @model.isWebchat()
        @hideResponse() if @model.isWebchatFinalized()

  getResponseContainer: ->
    @$el.find(".form-container.response-form")

  hideResponse: ->
    @getResponseContainer().hide()
    @trigger('adjustHeight')

  showResponse: ->
    @getResponseContainer().show()
    @trigger('adjustHeight')

  focusResponseBox: (responseView) =>
    responseBox = responseView.el
    scrollable = @$('.microscroll')
    # scroll and put response box at the bottom of the viewport
    scrollable.animate({scrollTop: responseBox.offsetTop - scrollable.height() + responseBox.offsetHeight})

  focusInteractionBox: (interactionView) =>
    interactionBox = interactionView.el
    scrollable = @$('.microscroll')
    # scroll and put interaction box at the top of the viewport
    scrollable.animate({scrollTop: interactionBox.offsetTop})

  updatePredefinedAnswers: ->
    @responseView.loadPredefinedTemplatesBtn() if @responseView

  onDetach: ->
    @responseView?.onDetach()
    @interactionsView.onDetach()

  onAttach: ->
    @responseView?.onAttach()
    @interactionsView.onAttach()

  _renderResponse: ->
    responseOptions = {
      ticketView: @
      notes: true
      responseTemplates: @responseTemplates
      tags: @model.getInteractionToResponse().tags()
      mainResponse: true
      responseTo: @model.getInteractionIdToResponse()
      isPrivate: @lastInteractionIsPrivate() unless @model.isByUser()
      socialAccounts: @options.socialAccounts
      email_multi_threadkey_enabled: @options.email_multi_threadkey_enabled
    }
    if @model.isEmail()
      @responseView?.onDetach() if @responseView
      @responseView = new Customer.Dashboard.TicketEmailResponseView(responseOptions)
    else
      @responseView.destroy() if @responseView
      if @model.isFacebook()
        @responseView = new Customer.Dashboard.FacebookTicketResponseView(responseOptions)
      else if @model.isInstagram()
        @responseView =  if @model.subType() == 'ig-message'
          new Customer.Dashboard.InstagramMessageTicketResponseView(responseOptions)
        else
          new Customer.Dashboard.InstagramCommentTicketResponseView(responseOptions)
      else
        @responseView = new Customer.Dashboard.TicketResponseView(responseOptions)
    @listenTo(@responseView, 'ticket:tab:closeRequired', @closeTicketTab)
    @listenTo(@responseView, 'note:saved', (content) => @model.get('notes').create({content: content}, wait: true))
    @listenTo(@responseView, 'validations:failed', @onValidationFail)
    @responseView.bind('onResponse', @onResponse)
    @responseView.bind('response:success', @onResponse)
    @responseView.bind('response:error', @onResponse)
    @responseView.bind('response:destroy', @onResponseDestroy)
    @responseView.render()

  lastInteractionIsPrivate: ->
    interactionToResponse = @model.getInteractionToResponse()
    if interactionToResponse
      return _.contains(interactionToResponse.get('available_reply_visibility'), 'private')

  renderResponse: =>
    @getResponseContainer().html(@_renderResponse().el)

  onSaveNote: =>
    @_keepCustomerSessionAlive()
    content = @$el.find('#note_text').val()
    @$el.find('#save_note').hide()
    @$el.find('#saving_note').show()
    @model.get('notes').create({content: content}, {
      wait: true
      success: =>
        @$el.find('#note_text').val('')
        @$el.find('#save_note').show()
        @$el.find('#saving_note').hide()
        @$el.find('.modal').modal('hide')
      error: =>
        console.log("Error saving note")
        @$el.find('#save_note').show()
        @$el.find('#saving_note').hide()
      }
    )

  onShowContextParticipants: =>
    if @contextInteractionsView?
      @$el.find('#context-interactions').show()
      @$el.find('#show-context-participants').hide()
      @$el.find('#hide-context-participants').show()
    else
      @contextInteractionsView = new Customer.Ticket.ContextInteractionsView(_.extend(@options, {ticketView: @}))
      @renderContextInteractionsView()
      @$el.find('#show-context-participants').hide()
      @$el.find('#loading-context-participants').show()

  onHideContextParticipants: =>
    @$el.find('#context-interactions').hide()
    @$el.find('#show-context-participants').show()
    @$el.find('#hide-context-participants').hide()

  toggleShowActiveParticipants: ->
    @$el.find('#loading-context-participants').hide()
    @$el.find('#hide-context-participants').show()

  onResponse: (response) =>
    if response.success
      @updateAfterResponse(response)
      if response.response_interaction
        if @model.interactionsNotPresentYet([response.response_interaction]).length > 0
          interaction = new Monitoring.Models.SocialContents.AnalysisUnitFactory().create(response.response_interaction, [])
          interaction.viewType = 'interaction'
          @model.interactions().push(interaction)
          @renderNewResponse(interaction)
      else
        @render()
      if @model.hasFooterReplyBox()
        @renderResponse()
        @responseView.loadPredefinedTemplatesBtn()
        @responseView.createResponseAttachment()
      @_scrollToEnd()
    else
      @failedResponse(response)

  updateAfterResponse: (response) ->
    @updateStatus(response.conversation.status)
    @model.updateAssignedToId(response.conversation.assigned_to_id)
    @model.updateAssignedToName(response.conversation.assigned_to_name)
    @model.updateUsersGroupId(response.conversation.users_group_id)
    @model.updateLockVersion(response.conversation.lock_version)

  failedResponse: (response) ->
    @render()
    window.showError(response.message)

  rollback: => # TODO: Se usa? Sino borrar toda la funcionalidad (backend + frontend)
    $.post("/customer/conversations/rollback", {id: @model.get('id')}, (response) => @onResponse(response) )
    @$el.find('#rollback_container').hide()

  onValidationFail: (errors, skipAttributesErrorDetail) =>
    msg = @ticketDetailsBoxView.onAttributesValidationError(errors, skipAttributesErrorDetail)
    showError msg if msg

  renderNewResponse: (interaction) ->
    @interactionsView.renderNewResponse(interaction)

  renderMore: (interactions) =>
    @interactionsView.renderMore(interactions)
    @responseView.updateTags(@model.getInteractionToResponse().tags()) if @responseView

  renderNew: (interactions, ticket_lock_version) =>
    @model.updateLockVersion(ticket_lock_version)
    @interactionsView.renderNew(interactions)
    @responseView.updateTags(@model.getInteractionToResponse().tags()) if @responseView
    @responseView.hideIsTyping() if @responseView
    @updatePredefinedAnswers()

  renderDistinguishedContent: () ->
    if @model.distinguishedContent()
      @distinguishedContent = obj: @model.distinguishedContent()
      @renderDistinguishedOnTop()

  renderDistinguishedOnTop: ->
    @distinguishedContent = new Customer.Ticket.InteractionView(
      model: @distinguishedContent.obj
      ticketView: this
      userProfileData: @_userProfileData()
    ).render()
    $(@distinguishedContent.el).addClass('clearfix distinguished collapsed')
    responseForm = @$el.find('#interactions')
    $(@distinguishedContent.el).insertBefore(responseForm)
    @listenTo(@distinguishedContent, 'clicked:user', @onClickUser) unless @distinguishedContent.isBrandContent()

  updateStatus: (status) ->
    @model.updateStatus(status)
    @updateStateButtons(status)

  updateStateButtons: (status = @model.attributes.status) ->
    @updateScheduleButton(status)
    @updateStatusButton(status)

  updateScheduleButton: (status) ->
    @addScheduledIndicator() if @model.get('userAppointment') && @model.get('userAppointment').date
    @toggleScheduleButton(status)

  toggleScheduleButton: (status = @model.attributes.status) ->
    @$el.find('#ticket-schedule').prop('disabled', status not in ['Pending', 'Assigned'])

  disableScheduleButton: (value = true) ->
    @$el.find('#ticket-schedule').prop('disabled', value)

  updateStatusButton: (status) ->
    @$el.find('.conv-resume-close').toggleClass('conversation-closed', status is 'Closed')

  createResponseAttachment: ->
    @responseView.createResponseAttachment()

  destroyResponseAttachment: ->
    @$el.find('.attachment-uploader').html('')

  adjustHeight: =>
    headerHeight = $('#main-header').outerHeight(true) || 0
    tabsHeight = $('#tabs-wrapper').outerHeight(true) || 0
    resumeHeight = @$el.find('.conv-resume').outerHeight(true)
    @$el.find('#nano-detail').css('height', "calc(100vh - 126px)")

  showHistory: =>
    @_keepCustomerSessionAlive()
    @ticketHistory.show()

  enableStateButtons: =>
    @processingTicket = false
    $('#reopen')[0]?.disabled = false
    $('#close')[0]?.disabled = false
    @updateStateButtons()

  disableStateButtons: =>
    $('#ticket-schedule')[0]?.disabled = true
    $('#reopen')[0]?.disabled = true
    $('#close')[0]?.disabled = true
    @processingTicket = true

  sendGroupNotifications: (assigned_to_group_id) =>
    selectedGroup = _.filter(@options.users_groups, (group) => ( group.id == assigned_to_group_id ))
    @sendNotifications(selectedGroup.name, selectedGroup[0].user_ids)

  sendNotifications: (assigned_to_name, users) =>
    $.ajax
      url: '/customer/conversations/notifications'
      type: 'POST'
      data:
        'notification': {
          'conversation_id': @model.id,
          'assigned_to_name': assigned_to_name,
          'users': users
        }

  onSelectTab: (dashboard) ->
    dashboard.history.clearState()
    dashboard.history.setConversation(@model.id).go()
    dashboard.showFilters(false)
    unless @scrolledToEnd # i love flags
      if (@model.type() == "email") && @model.attributes.email_order == 'desc'
        @_scrollToEnd()
      if (@model.type() == "email-user") && @model.attributes.email_user_order == 'desc'
        @_scrollToEnd()
      @scrolledToEnd = true

  onRefreshTab: (dashboard) ->
    @trigger('ticket:refresh:start')
    @model.fetch(
      success: (model, response) =>
        @headerView = new Customer.Ticket.TicketHeaderView(model: @model, data: @options)
        @render()
        @updateStateButtons()
        @trigger('ticket:refresh:success')
      error: (model, response) =>
        @manageError(response)
    )

  tabName: ->
    @model.id

  tabId: ->
    @model.id

  uniqueId: ->
    @model.id

  iconSelector: ->
    if @model.isByUser()
      @model.properType()
    else
      @model.subType()

  currentScrollPosition: () ->
    @$el.find('#nano-detail').scrollTop()

  scrollTo: (position) ->
    @$el.find('#nano-detail').scrollTop(position)

  getSignatures: ->
    new Customer.SignaturesCollection(@options.signatures)

  closeAllResponseBoxes: ->
    @interactionsView.closeAllResponseBoxes()

  onFollowChanged: ->
    @ticketDetailsBoxView.updateFollowValues()

  onResponseDestroy: =>
    @responseView.destroy() if @responseView
    @responseView = undefined
    @$el.find('.form-container').hide()

  _updateFutureAppointmentsList: ->
    $('#ticket-appointments-list-container').load('/customer/ticket/update_ticket_appointments')

  showIsTyping: ->
    if @responseView
      @responseView.showIsTyping()
    else
      console.log("User is typing but response box is closed")

  findDefinitionBehaviorView: (sub_type) ->
    definitions = [{sub_type: 'webchat_finalized', max_amount:1 }]
    _.find(definitions, {sub_type: sub_type})

  disableActionsAfterCut: ->
    @_disableActionsForCutTickets()
    @_disableCommunication()

  _disableCommunication: ->
    @responseView.removeResponseBox() if  @responseView
    @interactionsView.removeAllReplyButtons()

  _disableActionsForCutTickets: ->
    @interactionsView.removeAllCutTicketButtons()

  disableAllCutTicketButtons: ->
    @interactionsView.disableAllCutTicketButtons()
  enableAllCutTicketButtons: ->
    @interactionsView.enableAllCutTicketButtons()

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'

  closeModals: ->
    @$el.find('.modal').modal('hide')

  _onShowStatusEventsChange: (target) =>
    @showEventsCheckbox = target.currentTarget.checked
    @_setStatusEventsCheckbox(@showEventsCheckbox)

  _setStatusEventsCheckbox: (checked) ->
    @$el.find('#show-events-checkbox').prop('checked', checked)
    @interactionsView.changeShowStatusEvents(checked)

  _userProfileData: ->
    return {} unless @model.ownSubtype() == 'ig-user'
    interactionToUse = @model.allInteractions().find((interaction) ->
      interaction.subType() == 'ig-message' && !interaction.isBrandContent()
    )
    if interactionToUse == undefined
      {}
    else
      {
        avatar: interactionToUse.avatar(),
        name: interactionToUse.name(),
        username: interactionToUse.username()
      }
